export default "__VITE_ASSET__ad88dc56__"